import React, {FunctionComponent, useCallback, useContext} from 'react';
import {InvoiceContext} from "../../context/InvoiceContext";
import {PageContext} from "../../context/PageContext";
import moneyIcon from "../../assets/icons/money-bill-duotone.svg";

export const PaidPage: FunctionComponent = () => {
    const invoice = useContext(InvoiceContext);
    const pdfUrl = useContext(PageContext).pageData.pdf_url;
    const paidPdfUrl = useContext(PageContext).pageData.paid_pdf_url;

    const getMainPdf = useCallback(() => {
        if (!paidPdfUrl) {
            return <h3>You can download <a href={pdfUrl} download={true} target={'_blank'} rel={'noreferrer'}>pdf</a></h3>
        } else {
            return <h3>You can download <a href={pdfUrl} download={true} target={'_blank'} rel={'noreferrer'}>accepted pdf</a></h3>
        }
    }, [paidPdfUrl]);

    return (
        <div className='full-page-section'>
            <img src={moneyIcon} alt="reject" className="full-page-icon"/>
            <h1>{invoice.invoice_title} has been paid.</h1>
            {getMainPdf()}
            {paidPdfUrl &&
            <h3>You can download <a href={paidPdfUrl} download={true} target={'_blank'} rel={'noreferrer'}> paid pdf</a></h3>}
        </div>
    );
};
